// extracted by mini-css-extract-plugin
export var breadcrumb = "_16-3";
export var breadcrumbArrow = "_16-4";
export var breadcrumbs = "_16-0";
export var link = "_16-5";
export var sm = "_16-1";
export var xs = "_16-2";